import React from 'react';

const Memo = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.55627 13.1736V42.5695C8.61494 43.6343 9.07967 44.6361 9.85479 45.3686C10.6299 46.1011 11.6565 46.5084 12.7229 46.507H37.723C38.7894 46.5084 39.8159 46.1011 40.5911 45.3686C41.3663 44.6361 41.8309 43.6343 41.8896 42.5695V13.1736H8.55627Z"
        fill="#E7ECEF"
      />
      <path
        d="M41.8896 9.007C41.8896 7.90192 41.4507 6.8421 40.6692 6.06071C39.8878 5.27931 38.828 4.84033 37.723 4.84033H12.7229C11.6179 4.84033 10.5581 5.27931 9.77667 6.06071C8.99525 6.8421 8.55627 7.90192 8.55627 9.007V13.1737H41.8896V9.007Z"
        fill="#71E5A6"
      />
      <path
        d="M34.8142 19.4033H15.7171C15.2376 19.4033 14.849 19.8697 14.849 20.445V22.5283C14.849 23.1035 15.2376 23.57 15.7171 23.57H34.8142C35.2938 23.57 35.6823 23.1035 35.6823 22.5283V20.445C35.6823 19.8697 35.2938 19.4033 34.8142 19.4033Z"
        fill="#C7CED5"
      />
      <path
        d="M34.8142 26.6951H15.7171C15.2376 26.6951 14.849 27.1615 14.849 27.7367V29.8201C14.849 30.3953 15.2376 30.8617 15.7171 30.8617H34.8142C35.2938 30.8617 35.6823 30.3953 35.6823 29.8201V27.7367C35.6823 27.1615 35.2938 26.6951 34.8142 26.6951Z"
        fill="#C7CED5"
      />
      <path
        d="M34.8142 33.9866H15.7171C15.2376 33.9866 14.849 34.453 14.849 35.0282V37.1116C14.849 37.6868 15.2376 38.1532 15.7171 38.1532H34.8142C35.2938 38.1532 35.6823 37.6868 35.6823 37.1116V35.0282C35.6823 34.453 35.2938 33.9866 34.8142 33.9866Z"
        fill="#C7CED5"
      />
    </svg>
  );
};

export default Memo;
